import React, { Component } from 'react';
import { makeStyles } from '@mui/styles';
import {Paper, Tabs, Tab, Typography, Box, Grid} from '@mui/material';
import { Link } from 'react-router-dom';
import Global from "../../customlib/Global";
import DataCancelDashboard from '../DataPending/DataCancelDashboard';
import PerformaSalesByLabel from './PerformaSalesByLabel';
import PerformaCancelSales from './PerformaCancelSales';
import WeeklyPersenCancel from './WeeklyPersenCancel';
import Weekly from './Weekly';
import CancelByJam from './CancelByJam';
import ClosingAndAvgResponse from './ClosingAndAvgResponse/ClosingAndAvgResponse';
import SummaryDatabaseDataCancel from './SummaryDatabaseDataCancel';
import ContactLeadsReportHourly from '../ContactLeadsReport/ContactLeadsReportHourly';
import LeadsPerSections from './LadsPerSections';
import DataCancelDashboardNew from '../DataPending/DataCancelDashboardNew';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={1}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

class DashboardPerformaSales extends Component {

    state = { 
        value : 0,
    }

    useStyles = makeStyles({
        root: {
          flexGrow: 1
        },
      });

    // classes = useStyles();
    // const [value, setValue] = React.useState(0);

    componentDidMount() {
        this.setState({value: 0});
    }
    

    handleChange = (event, newValue) => {
        // setValue(newValue);
        this.setState({value:newValue});
    };

    render() { 
        return ( 
            <>
            <Paper className={this.useStyles.root} style={{marginTop: "10px", padding: "0px", backgroundColor: "#e7eef4"}}>
                <div className="container-fluid text-center">
                  <Grid container spacing={1}>
                      <Grid item sm={11} xs={11} textAlign={"left"} sx={{paddingLeft: "30px"}}>
                        {
                            !this.props.isMobile && (<h1>Dashboard Performa Sales</h1>)
                        }
                        {
                            this.props.isMobile && (<Box sx={{fontSize: "23px"}}>Dashboard Performa Sales</Box>)
                        }
                        </Grid>
                      <Grid item xs={1} sm={1} textAlign={"right"}>
                        {
                            !this.props.isMobile && (
                                <Link to="/">
                                    <div className="btn btn-danger">X</div>
                                </Link>
                            )
                        }

                        {
                            this.props.isMobile && (
                                <div className="btn btn-danger" onClick={this.props.onClose}>X</div>
                            )
                        }
                          
                      </Grid>
                  </Grid>
                </div>
                <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    centered
                    variant='scrollable'
                >
                    <Tab key="tab0" label="Issue Leads" wrapped />
                    <Tab key="tab1" label="Closing &amp; Avg Response" wrapped />
                    <Tab key="tab2" label="Performa Sales By Label" wrapped />
                    {/* <Tab key="tab2" label="Performa Cancel By Sales" wrapped /> */}
                    <Tab key="tab3" label="Weekly % Cancel" wrapped />
                    <Tab key="tab4" label="Weekly" wrapped />
                    <Tab key="tab5" label="Data Cancel" wrapped />
                    <Tab key="tab6" label="Detail Leads" wrapped />
                    <Tab key="tab7" label="Leads Per Sections" wrapped />
                    {/* <Tab key="tab2" label="Cancel By Jam" wrapped /> */}
                </Tabs>
            </Paper>
            <TabPanel value={this.state.value} index={0}>
                <DataCancelDashboardNew {...this.props}/>
            </TabPanel>
            <TabPanel value={this.state.value} index={1}>
                <ClosingAndAvgResponse {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={2}>
                <PerformaSalesByLabel {...this.props} />
            </TabPanel>
            {/* <TabPanel value={this.state.value} index={3}>
                <PerformaCancelSales />
            </TabPanel> */}
            <TabPanel value={this.state.value} index={3}>
                <WeeklyPersenCancel {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={4}>
                <Weekly {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={5}>
                <SummaryDatabaseDataCancel {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={6}>
                <ContactLeadsReportHourly {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={7}>
                <LeadsPerSections {...this.props} />
            </TabPanel>
            {/* <TabPanel value={this.state.value} index={6}>
                <CancelByJam />
            </TabPanel> */}
            </>
         );
    }
}
 
export default DashboardPerformaSales;